import {Text} from '@volkswagen-onehub/components-core';
import React from 'react';
import Select from 'react-select';
import useMediaQuery from '../hooks/useMediaQuery';
interface DropdownOption {
  label: string;
  value: string;
}

interface DropdownSelectProps {
  value?: DropdownOption['value'];
  label?: string;
  placeholder?: string;
  options: DropdownOption[];
  onSelect?: (value?: string) => void;
}

const DropdownSelect: React.FC<DropdownSelectProps> = (props) => {
  const {label, options, onSelect, placeholder = 'Please select'} = props;
  const {isMobile} = useMediaQuery();

  return (
    <div className="dropdown-select">
      <Text>
        <div style={{color: '#fff', marginBottom: 4, fontSize: 12}}>
          {label}
        </div>
      </Text>
      <Select
        value={options.find((option) => option.value === props.value)}
        placeholder={placeholder}
        onChange={(option) => onSelect?.(option?.value)}
        styles={{
          indicatorSeparator: (baseStyles) => {
            return {
              ...baseStyles,
              display: 'none',
            };
          },
          placeholder: (defaultStyles) => {
            return {
              ...defaultStyles,
              color: 'var(--1-white-000, #fff)',
              opacity: 0.5,
              fontSize: isMobile ? 14 : 16,
            };
          },
          singleValue: (defaultStyles) => {
            return {
              ...defaultStyles,
              color: 'var(--1-white-000, #fff)',
            };
          },
          control: (baseStyles) => {
            return {
              ...baseStyles,
              backgroundColor: 'transparent',
              color: 'white',
              border: 'none',
              borderBottom: '1px solid var(--1-white-000, #FFF)',
              outline: 'none',
              boxShadow: 'none',
              borderRadius: 0,
            };
          },
          input: (baseStyles) => {
            return {
              ...baseStyles,
              color: '#fff',
              outline: 'none',
              borderRadius: 0,
              fontSize: isMobile ? 14 : 16,
            };
          },
          menu: (baseStyles) => {
            return {
              ...baseStyles,
              backgroundColor: '#0161cb',
            };
          },
          option: (baseStyles, state) => {
            const isFocused = state.isFocused || state.isSelected;
            return {
              ...baseStyles,
              color: isFocused ? '#001E50' : '#fff',
              backgroundColor: isFocused ? '#fff' : baseStyles.backgroundColor,
              padding: 20,
            };
          },
          valueContainer: (baseStyles) => {
            return {
              ...baseStyles,
              padding: 0,
              outline: 'none',
            };
          },
        }}
        options={options}
      />
    </div>
  );
};

export default DropdownSelect;
